export default function initOrgAccordion() {
  const items = document.querySelectorAll(".org-group .item");
  if (!items.length) return;

  items.forEach((item) => {
    const title = item.querySelector(".item-title");
    const content = item.querySelector(".item-content");

    if (!title || !content) return;

    // Inject toggler if not exists
    let toggler = item.querySelector(".item-toggler");
    if (!toggler) {
      toggler = document.createElement("span");
      toggler.className = "item-toggler";
      title.appendChild(toggler);
    }

    // Toggle function
    function handleClick() {
      const isOpen = item.classList.contains("is-open");

      if (isOpen) {
        // Closing: set current height first, then animate to 0
        content.style.maxHeight = content.scrollHeight + "px";
        // Force reflow
        content.offsetHeight;
        content.style.maxHeight = "0";
        item.classList.remove("is-open");
      } else {
        // Opening: lock starting point first, then animate to scrollHeight
        content.style.maxHeight = "0";
        // Force reflow
        content.offsetHeight;
        // Add class for other styles (opacity, margin)
        item.classList.add("is-open");
        // Animate to target height
        content.style.maxHeight = content.scrollHeight + "px";

        // After transition, set to none to allow dynamic content
        content.addEventListener(
          "transitionend",
          () => {
            if (item.classList.contains("is-open")) {
              content.style.maxHeight = "none";
            }
          },
          { once: true }
        );
      }
    }

    // Click handlers
    title.addEventListener("click", handleClick);

    // Default open - init with max-height none
    item.classList.add("is-open");
    content.style.maxHeight = "none";
  });
}
